import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, SimpleChanges, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ColorPickerModule } from 'ngx-color-picker';
import { Lithology } from 'src/app/bo/geology/lithologie';
import { ProprieteAffichee } from 'src/app/bo/proprieteAffichee';
import { FonctionsService } from 'src/app/services/fonctions-partagees.service';
import { HttpService } from 'src/app/services/http.service';
import { UtilisateurService } from 'src/app/services/utilisateur.service';

@Component({
  selector: 'app-litho-gui',
  templateUrl: './litho-gui.component.html',
  styleUrls: ['./litho-gui.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, ColorPickerModule]
})
export class LithoGuiComponent implements OnInit {
  readonly currentRegionId = input<number>(undefined);
  readonly isAdminOrResReg = input<boolean>(false);


  table_width:number[] = [5,14,14,14,14,14,7,6,6];

  showErrorModif = false;
  showErrorNew = false;

  tabLithologies = signal<Lithology[]>([]);
  selectedLithology: Lithology = new Lithology();
  oldLithology: Lithology = new Lithology();

  newLithology: Lithology = new Lithology();
  proprietesAffichees: ProprieteAffichee[] = [];

  isModifiable = -1;
  lastToucheIndex = -1;
  isFooterFocus:boolean;



  constructor(
     private readonly http: HttpService,
     public utilService: UtilisateurService,
     private readonly fonctionsService: FonctionsService
     ) {
       this.proprietesAffichees = new Lithology().getProprietesAffichees();
    }

  ngOnInit(): void {
    this.getLithologiesByRegionId();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes['currentRegionId']){
      this.getLithologiesByRegionId();
    }
  }



  protected selectLithology(lithology: Lithology, index:number, e:any){
    if(this.selectedLithology.id === lithology.id) return;

    if(this.lastToucheIndex > -1 && this.oldLithology.id > 0 ){
      const current = [...this.tabLithologies()];
      current[this.lastToucheIndex] = this.oldLithology;
      this.tabLithologies.set(current);

      // this.translate.get('ERRORS_MESSAGE.NO_ITEM_SAVED').subscribe(trad => {
      //   this.fonctionsService.launch_toast(false, false, trad);
      // });

    }

    this.lastToucheIndex = index;
    this.oldLithology = Object.assign({}, lithology);

    this.selectedLithology = Object.assign({}, lithology)
    this.isModifiable = index;
    this.clearNew();
  }

  protected clearNew(){
    this.newLithology = new Lithology();
    this.isFooterFocus = false;

  }
  protected clearSelected(){
    this.selectedLithology = new Lithology();
  }

  protected newLithologyChange(){
    this.selectedLithology = new Lithology();
    this.isModifiable = -1;
    this.isFooterFocus = true;
  }

public ensureHashPrefix(color: string): string {
  if (!color) {
    return '#FFFFFF';
  }
  color = color.trim();
  if (!color.startsWith('#')) {
    color = '#' + color;
  }
  const hexColorRegex = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{4}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/;
  if (!hexColorRegex.test(color)) {
    return '#FFFFFF';
  }
  return color.toUpperCase();
}


  protected onFocusOutEvent(){
    this.isFooterFocus = false;
  }

  protected toggleIsActive(l: Lithology) {
    const newState = !l.isActive;
    const url = `Geology/site/toggle/lithology/${l.id}?isActive=${newState}`;
    this.http.put(url, {}).subscribe({
      next: () => {
        l.isActive = newState;
        this.tabLithologies.set([...this.tabLithologies()]);
      },
      error: () => {
        this.fonctionsService.launch_toast(false);
      }
    });
  }

  private getLithologiesByRegionId(){
    const regionId = this.currentRegionId() ?? this.utilService.currentRegionForSetupRegion.regionId;

    this.fonctionsService.loading_screen(true);

    const url = "Geology/GetAllLithologiesByRegionId/" + regionId;

    this.http.get<Lithology[]>(url).subscribe({
     next: result =>{
      this.tabLithologies.set(result);
    } ,
    error: (error: HttpErrorResponse) => {
      if(error.status === 401 || error.status === 403){
    console.log(error.error);
      }
      this.fonctionsService.launch_toast(false);
      this.fonctionsService.loading_screen(false);
    },
    complete:() => {
       this.fonctionsService.loading_screen(false);
     }
   })
  }

  protected createLithology(){
    if(this.newLithology.name === '' || this.newLithology.code === '' || this.newLithology.rockType === '' ){
        this.showErrorNew = true;
        setTimeout(() => {
        this.showErrorNew = false;
      }, 1500);
      return;
    }

    // Ensure color starts with #
    this.newLithology.color = this.ensureHashPrefix(this.newLithology.color);

    this.fonctionsService.loading_screen(true);
    this.newLithology.regionId = this.currentRegionId();
    const url = "Geology/CreateLithology";
    this.http.post(url, this.newLithology).subscribe({
     next: result =>{
      this.clearNew();
      this.clearSelected();
      this.getLithologiesByRegionId();
      this.fonctionsService.launch_toast(true);
      this.fonctionsService.loading_screen(false);
     } ,
     error: (error: HttpErrorResponse) => {
      if(error.status === 401 || error.status === 403){
    console.log(error.error);
      }
      this.fonctionsService.launch_toast(false);
      this.fonctionsService.loading_screen(false);
     },
     complete:() => {
      this.fonctionsService.loading_screen(false);
     }
   })
  }

  protected update(l:Lithology, index:number){
    if(l.name === '' || l.code === '' || l.rockType === ''){
      this.showErrorModif = true;
      setTimeout(() => {
      this.showErrorModif = false;
    }, 1500);
    return;
  }

    // Ensure color starts with #
    l.color = this.ensureHashPrefix(l.color);

      this.updateApi(this.tabLithologies()[index]).subscribe({
        next: result =>{
          this.clearNew();
          this.clearSelected();
          this.oldLithology = new Lithology();
          this.lastToucheIndex = -1;
          this.isModifiable = -1;
          this.fonctionsService.loading_screen(false);
          this.fonctionsService.launch_toast(true);
        } ,
        error: (error: HttpErrorResponse) => {
          if(error.status === 401 || error.status === 403){
        console.log(error.error);
          }
          this.fonctionsService.launch_toast(false);
          this.fonctionsService.loading_screen(false);
        },
        complete:() => {
          this.fonctionsService.loading_screen(false);
        }
      })
  }

  protected delete(selectedLithology:Lithology){
    selectedLithology.regionId = 0;
      this.updateApi(selectedLithology).subscribe({
        next: result =>{
         this.clearNew();
         this.clearSelected();
         this.oldLithology = new Lithology();
         this.lastToucheIndex = -1;
         this.isModifiable = -1;
         this.fonctionsService.loading_screen(false);
         this.tabLithologies.set(this.tabLithologies().filter((item) => item.id !== selectedLithology.id));
         this.fonctionsService.launch_toast(true);
        } ,
        error: (error: HttpErrorResponse) => {
         if(error.status === 401 || error.status === 403){
       console.log(error.error);
         }
         this.fonctionsService.launch_toast(false);
         this.fonctionsService.loading_screen(false);
        },
        complete:() => {
         this.fonctionsService.loading_screen(false);
        }
      })
  }

  private updateApi(selectedLithology:Lithology){
    this.fonctionsService.loading_screen(true);
    const url = "Geology/UpdateLithology";
    return this.http.put(url, selectedLithology)
  }

}
